/* Conneqt.Point — leichte Interaktionen, keine schweren Libraries */
(function(){
  'use strict';

  /* Reveal on scroll */
  function initReveal(){
    var els = document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window) || !els.length){
      els.forEach(function(e){e.classList.add('in');}); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    },{threshold:.12});
    els.forEach(function(e){io.observe(e);});
  }

  /* PDP swipe carousel: dots + thumbnails synced with scroll */
  function initGallery(){
    document.querySelectorAll('[data-carousel]').forEach(function(car){
      var wrap = car.closest('[data-gallery]') || car.parentNode;
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-dot]'));
      var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-thumb-index]'));
      function setActive(i){
        dots.forEach(function(d,di){ d.classList.toggle('is-active', di===i); });
        thumbs.forEach(function(t){ t.classList.toggle('is-active', parseInt(t.dataset.thumbIndex,10)===i); });
      }
      function goTo(i){ car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); }
      dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(parseInt(d.dataset.dot,10)); }); });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.dataset.thumbIndex,10)); }); });
      var raf;
      car.addEventListener('scroll', function(){
        if(raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){
          var i = Math.round(car.scrollLeft / car.clientWidth);
          setActive(i);
        });
      }, { passive:true });
    });
  }

  /* Mobile nav toggle */
  function initNav(){
    var t = document.querySelector('[data-nav-toggle]');
    var m = document.querySelector('[data-mobile-nav]');
    if(t && m){ t.addEventListener('click',function(){
      var open = m.classList.toggle('open');
      t.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }); }
  }

  /* Sticky header shadow on scroll */
  function initHeader(){
    var h = document.querySelector('[data-c3-header]');
    if(!h) return;
    var onScroll = function(){ h.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  }

  document.addEventListener('DOMContentLoaded',function(){
    initReveal(); initGallery(); initNav(); initHeader();
  });
})();
